import { Divider, styled } from '@material-ui/core';

const VerticalDivider = styled(Divider)(() => ({
  height: 56,
}));

export default VerticalDivider;
